import styled from 'styled-components';

interface BoxProps {
  alignItems?: string;
}

const Box = styled.div<BoxProps>`
  width: 100%;
  background-color: #ffffff;
  border-radius: 16px;

  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.alignItems ? props.alignItems : 'stretch')};

  gap: 20px;
  padding: 20px;

  box-shadow: rgb(204, 219, 232) 3px 3px 6px 0px inset,
    rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;

  position: relative;
`;

export default Box;
